var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 87,
    viewBox: "0 0 99 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(-144 -5910)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_8",
    "data-name": "Polygon 8",
    d: "M74.25,0,99,43.5,74.25,87H24.75L0,43.5,24.75,0Z",
    transform: "translate(144 5910)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Property_1_bold",
    "data-name": "Property 1=bold",
    width: 24,
    height: 24,
    transform: "translate(182 5942)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(182 5942)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.37,6.09a6.854,6.854,0,0,1-3,5.6L8.03,14.64a1,1,0,0,1-1.68.23L4.87,13.09A7.743,7.743,0,0,1,0,11.41l.6-.71A8.719,8.719,0,0,0,8.87,2.23,8.337,8.337,0,0,0,8.56,0a6.938,6.938,0,0,1,3.81,6.09Z",
    transform: "translate(191.63 5948.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M15,7a7.262,7.262,0,0,1-7.5,7l-.93,1.12-.55.66a1,1,0,0,1-1.68-.23L3,12.6A6.854,6.854,0,0,1,0,7,7.262,7.262,0,0,1,7.5,0a7.514,7.514,0,0,1,6.8,4.07A6.458,6.458,0,0,1,15,7ZM10.75,7A.755.755,0,0,0,10,6.25H5a.75.75,0,0,0,0,1.5h5A.755.755,0,0,0,10.75,7Z",
    transform: "translate(184 5944)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMess);
export default __webpack_public_path__ + "static/media/mess.6030f42eed4832c037f462ef5d4c95d7.svg";
export { ForwardRef as ReactComponent };